// Resumen corto de 5 columnas (Cristales, Franquicia, Cobertura en Exterior,
// Auxilio, Granizo) que consumen la Grilla y el Slider de precios de Moto, con
// el mismo mapeo que Auto (moto opera siempre en AR).
//
// Vive acá (y no en utils) porque es una copia propia de Moto: si cambia, no
// afecta a Auto. Está en su archivo para poder testearla sin levantar Precios.

export const armarDescResumen = (descripciones: any[]): string[] => {
  const descripcionMap: { [nombre: string]: string } = {};
  (descripciones || []).forEach((desc: any) => {
    if (desc?.Nombre != null) {
      descripcionMap[desc.Nombre.toUpperCase().trim()] = desc.Descripcion || "No";
    }
  });
  return [
    descripcionMap["Cristales Laterales".toUpperCase()] || "No",
    descripcionMap["Daño Parcial por Accidente con franquicia".toUpperCase()] || "No aplica",
    descripcionMap["Cobertura en Exterior".toUpperCase()] || "No",
    descripcionMap["Auxilio Mecánico y Remolque".toUpperCase()] || "No",
    descripcionMap["Granizo".toUpperCase()] || "No",
  ];
};
